import { format, isThisYear, isToday } from 'date-fns';
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';
import { DateTimeUtils, fp as _ } from '@onsolve/onsolve-ui-components';
export const formattedDateField = (date, dateFormat = 'MMM d, yyyy h:mm aa') => {
    if (date) {
        return format(new Date(date), dateFormat);
    }
};
export const applyTimeZone = (date, tz) => {
    if (_.isEmpty(tz)) {
        return date;
    }
    const utc = zonedTimeToUtc(date, 'UTC').toISOString();
    const offsetString = tz.name === 'UTC' ? 'UTC' : DateTimeUtils.getOffsetString(tz.name);
    return utcToZonedTime(utc, offsetString);
};
export const formattedDate = (date) => {
    const formattedDate = new Date(date);
    if (isToday(formattedDate)) {
        return format(formattedDate, 'p');
    }
    if (isThisYear(formattedDate)) {
        return format(formattedDate, 'LLL d');
    }
    return format(formattedDate, 'P');
};
